module.exports = __webpack_public_path__ + "static/media/workPvcCoatings3.162fcd92.jpg";